export default __webpack_public_path__ + "static/media/ic_monthly_sub.946b3050.png";